import { render, staticRenderFns } from "./setMeal.vue?vue&type=template&id=300e2524&scoped=true&"
import script from "./setMeal.vue?vue&type=script&lang=js&"
export * from "./setMeal.vue?vue&type=script&lang=js&"
import style0 from "./setMeal.vue?vue&type=style&index=0&id=300e2524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!C:\\Users\\86177\\AppData\\Roaming\\npm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300e2524",
  null
  
)

export default component.exports